import type { QuestionType } from '@mentimeter/http-clients';

export const getIsQuizSlide = (type: QuestionType) =>
  ['quiz', 'quiz_open', 'quiz_leaderboard'].includes(type);
